import { render, staticRenderFns } from "./AncestralTabletsEngravingPreview.vue?vue&type=template&id=35b81701&"
import script from "./AncestralTabletsEngravingPreview.vue?vue&type=script&lang=js&"
export * from "./AncestralTabletsEngravingPreview.vue?vue&type=script&lang=js&"
import style0 from "./AncestralTabletsEngravingPreview.vue?vue&type=style&index=0&id=35b81701&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports